import $api from "../libs/devhand.api";

$api.addController("account", "/account", {
  signIn: { method: "post", path: "/signin" },
  signUp: { method: "post", path: "/signup" },
  resetPwd: { method: "post", path: "/resetpwd" },
  setPassword: { method: "post", path: "/setpassword" },
});

$api.addController("company", "/api/v1/company", {
  getUsers: { method: "get", path: "/users" },
  getInvitations: { method: "get", path: "/invitations" },
  getJoins: { method: "get", path: "/joins" },
  setAutoJoin: { method: "post", path: "/set-auto-join" },
  enforceMfa: { method: "post", path: "/enforce-mfa" },
  resolveJoin: { method: "post", path: "/join-resolve" },
  changeInvitationRole: { method: "put", path: "/invitations/{internalId}/role" },
  removeInvitation: { method: "delete", path: "/invitations/{internalId}" },
  prolongInvitation: { method: "put", path: "/invitations/{internalId}" },
  inviteUser: { method: "post", path: "/users/invite" },
  removeUser: { method: "delete", path: "/users/{id}" },
  userProjects: { method: "put", path: "/users/{id}/projects" },
});

$api.addController("users", "/api/v1/users", {
  changeRole: { method: "put", path: "/{id}/role" },
  updateProfile: { method: "put", path: "/me" },
  setSettings: { method: "put", path: "/me/settings" },
  getSettings: { method: "get", path: "/me/settings" },
});

$api.addController("advisor", "/api/v1/advisor", {
  getOverview: { method: "get", path: "/{projectCode}/overview" },
});

$api.addController("activitylogs", "/api/v1/activitylogs", {
  search: { method: "post", path: "/{projectCode}/search" },
});

$api.addController("feedbacks", "/api/v1/feedbacks", {
  getFeedbacks: { method: "get", path: "/{projectCode}" },
  solve: { method: "post", path: "/{projectCode}/{id}/solve" },
  unsolve: { method: "delete", path: "/{projectCode}/{id}/solve" },
  delete: { method: "delete", path: "/{projectCode}/{id}" },
  saveSettings: { method: "post", path: "/{projectCode}" },
  getMoods: { method: "get", path: "/{projectCode}/moods" },
  getNPSInfo: { method: "get", path: "/{projectCode}/moods/nps" },
});

$api.addController("projects", "/api/v1/projects", {
  getAll: { method: "get", path: "/" },
  get: { method: "get", path: "/{id}" },
  create: { method: "post", path: "/" },
  generateKey: {
    method: "post",
    path: "/{projectCode}/generate-encryption-key",
  },
  saveGeneral: { method: "put", path: "/general" },
  saveAdminSetings: { method: "put", path: "/{projectCode}/admin-settings" },
  saveData: { method: "put", path: "/data" },
  getData: { method: "get", path: "/data" },
  saveTourDesign: { method: "put", path: "/tour-design" },
  saveContextHelpDesign: { method: "put", path: "/context-help-design" },
  saveFeedbackDesign: { method: "put", path: "/feedback-design" },
  getAssignedUsers: { method: "get", path: "/users" },
  setIsInstalled: { method: "put", path: "/{projectCode}/settings/installed" },
  checkIfInstalled: {
    method: "get",
    path: "/{projectCode}/settings/installed",
  },
  sendExtensionInfo: {
    method: "post",
    path: "/{projectCode}/settings/send-extension-info",
  },
  sendCodeSnippetInfo: {
    method: "post",
    path: "/{projectCode}/settings/send-code-snippet-info",
  },
  isReceiving: { method: "get", path: "/{projectCode}/settings/is-receiving" },
  remove: { method: "delete", path: "/{projectCode}" },
  autosaveThing: { method: "post", path: "/{projectCode}/autosave-thing" },
  saveExtensionState: { method: "put", path: "/extension" },
  setFeatureFlag: { method: "put", path: "/{projectCode}/feature-flag" },
  removeFeatureFlag: { method: "delete", path: "/{projectCode}/feature-flag" },
  setDebuggerState: {
    method: "put",
    path: "/{projectCode}/general/debugger-state",
  },
  generateSampleData: {
    method: "post",
    path: "/{projectCode}/general/sample-data",
  },
  updateAppUrl: { method: "put", path: "/{projectCode}/general/app-url" },
  cloneFullKb: { method: "put", path: "/{projectCode}/general/clone-kb" },
});

$api.addController("tours", "/api/v1/tours", {
  getList: { method: "get", path: "/{projectCode}" },
  get: { method: "get", path: "/{projectCode}/{id}" },
  create: { method: "post", path: "/{projectCode}" },
  save: { method: "put", path: "/{projectCode}/{id}" },
  delete: { method: "delete", path: "/{projectCode}/{id}" },
  restart: { method: "post", path: "/{projectCode}/{id}/restart" },
  restartForUser: {
    method: "post",
    path: "/{projectCode}/{id}/restart-for-user",
  },
  duplicate: { method: "post", path: "/{projectCode}/{id}/duplicate" },

  publish: { method: "post", path: "/{projectCode}/{id}/publish" },
  unpublish: { method: "delete", path: "/{projectCode}/{id}/publish" },

  restartAllToursForUser_DANGEROUS: {
    method: "post",
    path: "/{projectCode}/restart-all-for-user",
  },
});

$api.addController("contextHelp", "/api/v1/contexthelp", {
  getList: { method: "get", path: "/{projectCode}" },
  get: { method: "get", path: "/{projectCode}/{id}" },
  create: { method: "post", path: "/{projectCode}" },
  save: { method: "put", path: "/{projectCode}/{id}" },
  saveSettings: { method: "put", path: "/{projectCode}/{id}/settings" },
  delete: { method: "delete", path: "/{projectCode}/{id}" },
  duplicate: { method: "post", path: "/{projectCode}/{id}/duplicate" },
  restart: { method: "post", path: "/{projectCode}/{id}/restart" },
  restartForUser: {
    method: "post",
    path: "/{projectCode}/{id}/restart-for-user",
  },

  publish: { method: "post", path: "/{projectCode}/{id}/publish" },
  unpublish: { method: "delete", path: "/{projectCode}/{id}/publish" },
});

$api.addController("insights", "/api/v1/insights", {
  getTourCardsPerformance: {
    method: "get",
    path: "/{projectCode}/tours/{id}/cards",
  },
  getTourGeneralPerformance: {
    method: "get",
    path: "/{projectCode}/tours/{id}/general",
  },
  getContextHelpGeneralPerformance: {
    method: "get",
    path: "/{projectCode}/contexthelps/{id}/general",
  },
  getContextHelpTopUrls: {
    method: "get",
    path: "/{projectCode}/contexthelps/{id}/topurls",
  },
  getContextHelpTopUrlTemplates: {
    method: "get",
    path: "/{projectCode}/contexthelps/{id}/topurltemplates",
  },
  getChangelogsGeneralPerformance: {
    method: "get",
    path: "/{projectCode}/changelogs/general",
  },
  getMoodsOverview: { method: "post", path: "/{projectCode}/moods-overview" },
  getMoodsOnTimeline: { method: "post", path: "/{projectCode}/moods-timeline" },
  initializeMoods: { method: "post", path: "/{projectCode}/moods-init" },
  getUsers: { method: "get", path: "/{projectCode}/users" },
  getUserDetailById: { method: "get", path: "/{projectCode}/user-detail/{id}" },
  getChecklistGeneralPerformance: {
    method: "get",
    path: "/{projectCode}/checklists/{id}/general",
  },
});

$api.addController("changelogs", "/api/v1/changelogs", {
  getAll: { method: "get", path: "/{projectCode}" },
  get: { method: "get", path: "/{projectCode}/{id}" },
  save: { method: "put", path: "/{projectCode}/{id}" },
  remove: { method: "delete", path: "/{projectCode}/{id}" },
  publish: { method: "post", path: "/{projectCode}/{id}/publish" },
  publishScheduled: {
    method: "post",
    path: "/{projectCode}/{id}/publish-scheduled",
  },
  unpublish: { method: "post", path: "/{projectCode}/{id}/unpublish" },
  getConfig: { method: "get", path: "/{projectCode}/config" },
  saveConfig: { method: "put", path: "/{projectCode}/config" },
  duplicate: { method: "put", path: "/{projectCode}/{id}/duplicate" },

  createChannel: { method: "post", path: "/{projectCode}/channels" },
  getChannelConfig: {
    method: "get",
    path: "/{projectCode}/channels/{id}/config",
  },
  saveChannelConfig: {
    method: "put",
    path: "/{projectCode}/channels/{id}/config",
  },
  saveChangelogToChannel: {
    method: "put",
    path: "/{projectCode}/channels/{id}/items",
  },
  deleteChannel: { method: "delete", path: "/{projectCode}/channels/{id}" },
});

$api.addController("integrations", "/api/v1/integrations", {
  saveFeedbackSettings: {
    method: "put",
    path: "/settings/all/feedback/{projectCode}",
  },
  saveAlertsSettings: {
    method: "put",
    path: "/settings/all/alerts/{projectCode}",
  },
  resetNewFeedbackWebhookToken: {
    method: "post",
    path: "/settings/webhooks/newfeedback/token/{projectCode}",
  },
  disableNewFeedbackWebhook: {
    method: "delete",
    path: "/auth/webhook/newfeedback/{projectCode}",
  },
  enableNewFeedbackWebhook: {
    method: "post",
    path: "/auth/webhook/newfeedback/{projectCode}",
  },
  disableNewFeedbackEmail: {
    method: "delete",
    path: "/auth/email/newfeedback/{projectCode}",
  },
  enableNewFeedbackEmail: {
    method: "post",
    path: "/auth/email/newfeedback/{projectCode}",
  },
  disableAlertsDigestEmail: {
    method: "delete",
    path: "/auth/email/alertsdigest/{projectCode}",
  },
  enableAlertsDigestEmail: {
    method: "post",
    path: "/auth/email/alertsdigest/{projectCode}",
  },
});

$api.addController("buttons", "/api/v1/buttons", {
  saveDesign: { method: "put", path: "/{projectCode}/design" },
  save: { method: "put", path: "/{projectCode}" },
  saveAll: { method: "put", path: "/{projectCode}/all" },
  activate: { method: "post", path: "/{projectCode}/activation" },
  deactivate: { method: "delete", path: "/{projectCode}/activation" },
});

$api.addController("segments", "/api/v1/segments", {
  create: { method: "post", path: "/{projectCode}" },
  save: { method: "put", path: "/{projectCode}/{id}" },
  delete: { method: "delete", path: "/{projectCode}/{id}" },
  duplicate: { method: "post", path: "/{projectCode}/{id}/duplicate" },
});

$api.addController("diag", "/api/v1/experience-diagnostic", {
  list: { method: "get", path: "/{projectCode}/list/tour/{id}" },
  resolveItem: { method: "delete", path: "/{projectCode}/item/{id}" },
  resolveBulk: { method: "delete", path: "/{projectCode}/item/bulk" },
});

$api.addController("customerCenter", "/api/v1/customer-center/{projectCode}", {
  getArticleContentById: { method: "get", path: "/article-contents/{id}" },
  getSearchStats: { method: "get", path: "/stats/keywords" },
  getAllArticles: { method: "post", path: "/articles" },
});

$api.addController("visualEvents", "/api/v1/visual-events", {
  saveDescriptor: { method: "put", path: "/{projectCode}/{id}/descriptor" },
});

$api.addController("events", "/api/v1/events", {
  getAggregation: {
    method: "get",
    path: "/{projectCode}/metadata/events/counts",
  },
});

export default $api;
